<template>
  <span id="edit-email-template">
    <v-btn icon color="black" class="button-edit" @click="dialogEdit = true">
      <img
        src="/images/icons/edit_user.svg"
        alt="edit-email-template"
        style="vertical-align: middle; max-width: 26px;"
      />
    </v-btn>
    <v-dialog v-model="dialogEdit" max-width="1000">
      <v-card>
        <v-card-title class="tw-mt-4">
          <div class="tw-font-bold tw-text-xl">แก้ไขอีเมล template</div>
        </v-card-title>
        <v-card-text class="tw-pb-0">
          <v-row>
            <v-col>
              <v-text-field
                v-model="emailTemplate.title"
                label="title"
                class="input-style"
                outlined
              ></v-text-field>
              <v-textarea
                v-model="exTitle"
                label="title example"
                class="input-style"
                rows="1"
                outlined
                readonly
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="emailTemplate.body"
                label="body"
                class="input-style"
                rows="20"
                outlined
              ></v-textarea>
              <v-textarea
                v-model="exBody"
                label="body example"
                class="input-style"
                rows="3"
                outlined
                readonly
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <save-alert
          :status="updateStatus"
          error-text="แก้ไขข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"
          success-text="แก้ไขข้อมูลสำเร็จ"
          v-if="updateStatus"
        ></save-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black darken-1"
            text
            @click="dialogEdit = false"
            :disabled="loading"
            class="tw-tracking-normal tw-text-lg"
          >
            <v-icon left class="tw-text-2xl">mdi-close-circle-outline</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="updaetEmailTemplate"
            v-if="userData"
            :disabled="loading"
            class="tw-tracking-normal tw-text-lg"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="green"
              style="margin-right: 10px;"
            ></v-progress-circular>
            <v-icon left class="tw-text-2xl">mdi-plus-circle-outline</v-icon>
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapState } from "vuex";
import fc from "@/firebaseConfig";

export default {
  name: "EditEmailTemplate",
  props: {
    emailTemplate: Object
  },
  components: {},
  data() {
    return {
      dialogEdit: false,
      exTitle: `ขอบคุณสำหรับการสั่งซื้อ ([docName] [docNo])`,
      exBody: `<div class='main-body'>
  <div class='email-body'>
    <div class='logo'>
    <img height='40px' src='[imageLogoUrl]=h80'/>
    </div>
    <p><strong>เรียน</strong> [customerName]</p>
    <p>[companyNameTH] ได้นำส่ง e-Tax Invoice & e-Receipt ผ่านระบบ ท่านสามารถดาวน์โหลด [docName] เลขที่ [docID] ไฟล์ตามเอกสารแนบ</p>
    <div class='download-area'><a href='[docSignedPdfUrl]' class='download-button'>ดาวน์โหลด</a></div>
    <p class='small'>เอกสารนี้เป็นเอกสารต้นฉบับและนำส่งสรรพากรด้วยวิธีอิเล็กทรอนิกส์ เมื่อพิมพ์แล้ว เอกสารที่พิมพ์ถือเป็นสำเนา</p>
    <div class='line'></div>
    <p class='small'>หากมีข้อสงสัยหรือต้องการรายละเอียดเพิ่มเติม ติดต่อได้ที่ เบอร์โทรศัพท์ [companyOfficeNumber] หรือ ส่งคำถามมาที่ [companyEmail]</p>
    <p class='small'>ขอบคุณที่ให้ความสนับสนุน</p>
    <p class='small'>[companyNameTH]</p>
  </div>
  <div class='footer'>
    <div class='line'></div>
    <div class='footer-content'>
    <span class='powered-by'>Powered by</span> <a class='phasi' href='https://phasicharoen.com'>ภาษีเจริญ.com</a>
    </div>
  </div>
</div>`
    };
  },
  computed: mapState({
    userData: state => state.user.userData,
    loading: state => state.user.loading,
    updateStatus: state => state.user.updateDataStatus
  }),
  methods: {
    updaetEmailTemplate: async function() {
      const companyID = this.$route.params.companyId;
      await fc.db
        .doc(`Companies/${companyID}/EmailTemplates/${this.emailTemplate.id}`)
        .set(
          {
            title: this.emailTemplate.title,
            body: this.emailTemplate.body
          },
          { merge: true }
        );

      this.dialogEdit = false;
    }
  }
};
</script>

<style lang="scss">
#edit-user {
  .input-style.v-input .v-input__slot {
    border-radius: 10px;
  }

  .v-text-field__details {
    display: none !important;
  }

  .button-edit {
    margin-right: 6px;
  }
}
</style>
